module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/credit_2x-0aef43113b83a696e5c7ae51e8ca0a00.png";